import { apiGetOffer } from "../api/apiGetOffer";
import { ACCORDION_LINKS } from "../utils/constants";
import { apiGetOfferDocuments } from "../api/apiGetOfferDocuments";
import { changeOfferResetState, changeOfferTypeSetPopupOpen } from "./changeOfferType";
import { apiCheckCoupon } from "../api/apiCheckCoupon";

export const OFFER_TYPE = {
    bio: 'bio',
    mono: 'mono',
    standard: 'standard',
    variable: 'variabile',
}

export const OFFER_ICON = {
    gas: 'Gas',
    energy: 'OrionPlugWhite',
    both: 'GasPlug',
}

const initialState = {
    // Current selected energy. It's a copy of either energyMono or energyBio
    energy: [],
    energyMono: [],
    energyBio: [],
    gas: [],
    benefits: [],
    offerType: '',
    offerId: null,
    icon: null,
    name: '',
    offerLinks: [],
    offerLinksMono: [],
    offerLinksBio: [],
    coupon: null,
    isCouponInvalid: false,
};

const OFFER_SET = 'OFFER_SET';
const offerSet = (offer, offerId, offerLinks, offerLinksBio, offerLinksMono, coupon) => {
    return { type: OFFER_SET, offer, offerId, offerLinks, offerLinksBio, offerLinksMono, coupon }
}

const OFFER_COUPON_INVALID = 'OFFER_COUPON_INVALID';
export const offerCouponInvalid = () => ({ type: OFFER_COUPON_INVALID });

export const offerChange = newType => (dispatch, getState) => {
    const { offer } = getState();
    if (newType === OFFER_TYPE.bio) {
        dispatch(offerSet(
            { ...offer, energy: [...offer.energyBio], offerType: newType }, 
            offer.offerId, 
            offer.offerLinksBio,
            offer.offerLinksBio,
            offer.offerLinksMono,
        ));
    } else {
        dispatch(offerSet(
            { ...offer, energy: [...offer.energyMono], offerType: newType }, 
            offer.offerId, 
            offer.offerLinksMono,
            offer.offerLinksBio,
            offer.offerLinksMono,
        ));
    }
}

export const offerGetFromApi = ({ offerId, coupon, offerType = OFFER_TYPE.standard, shouldShowPopupSelectedType = false }) => {
    return async (dispatch) => {
        try {
            console.log('Getting offer', offerId, offerType, coupon)
            if (!offerId) {
                window.location = "https://www.vivigas.it/prodotti/";
            }

            // Check coupon
            try {
                await apiCheckCoupon(offerId, coupon || '');
            } catch (error) {
                if (error.response.status === 400) {
                    return dispatch(offerCouponInvalid());
                }
            }

            // const offer = {"energy":[{"label":"Fascia 0","value":"0,0299 \u20ac\/kWh"}],"energyBio":[{"label":"Fascia 1","value":"0,0353 \u20ac\/kWh"},{"label":"Fascia 2-3","value":"0,0268  \u20ac\/kWh"}],"gas":[{"label":"P","value":"0,184200 \u20ac\/Smc"},{"label":"Fino al","value":"23\/01\/2020"}],"benefits":["Risparmi fino a 252\u20ac*","Buono Amazon da 50\u20ac**"],"nomeOfferta":"VIVIweb LuceGas","tipologiaUtenza":[{"term_id":18,"name":"Dual","slug":"dual","term_group":0,"term_taxonomy_id":18,"taxonomy":"utenze_category","description":"","parent":0,"count":6,"filter":"raw"}],"icona":"GasPlug","tipologiaTariffa":"variabile"}
            const offer = await apiGetOffer(offerId);
            if (!offer.energyBio) offer.energyBio = [];

            let offerDocuments = [];
            let offerLinksMono = [];
            let offerLinksBio = [];
            try {
                offerDocuments = await apiGetOfferDocuments(offerId);
                offerDocuments = offerDocuments.filter(document => document.url && document.label);
            } catch (error) {
                // If error it remains an empty array
            }

            if (!offer || !offer.nomeOfferta) {
                window.location = "https://www.vivigas.it/prodotti/";
            }

            // Extract "fino al"
            const labelToFilter = 'fino al'.toUpperCase();
            let validUntil = '';
            validUntil = offer.energy.find(o => o.label.toUpperCase() === labelToFilter);
            if (!validUntil) {
                validUntil = offer.energyBio.find(o => o.label.toUpperCase() === labelToFilter);
            }
            if (!validUntil) {
                validUntil = offer.gas.find(o => o.label.toUpperCase() === labelToFilter);
            }
            if (validUntil) {
                validUntil = validUntil.value;
            }

            const offerEnergyMono = offer.energy.filter(o => o.label.toUpperCase() !== labelToFilter);
            const offerEnergyBio = offer.energyBio.filter(o => o.label.toUpperCase() !== labelToFilter);
            const offerGas = offer.gas.filter(o => o.label.toUpperCase() !== labelToFilter);

            const parsedOffer = {
                name: offer.nomeOfferta,
                gas: offerGas,
                validUntil,
                benefits: offer.benefits,
                energyMono: offerEnergyMono,
                energyBio: offerEnergyBio,
                isGreenEnergy: offer.energiaVerde,
                shortDescription: offer.descrizioneOfferta,
            };

            parsedOffer.offerType = offerType;

            if (offerType === OFFER_TYPE.bio) {
                parsedOffer.energy = offerEnergyBio || [];
            } else {
                parsedOffer.energy = offerEnergyMono || [];
            }

            if (parsedOffer.energy.length > 0 && parsedOffer.gas.length > 0) {
                parsedOffer.icon = OFFER_ICON.both;
            } else if (parsedOffer.energy.length > 0) {
                parsedOffer.icon = OFFER_ICON.energy;
            } else {
                parsedOffer.icon = OFFER_ICON.gas;
            }

            if (
                offerDocuments.length > 0
                && parsedOffer.energy
                && Array.isArray(parsedOffer.energy)
                && parsedOffer.energy.length > 0
            ) {
                console.log('Filtering documents');
                offerLinksMono = offerDocuments.filter(document => {
                    if (!document.url || !document.label) return false;

                    return document.url.toUpperCase().indexOf('BIO') === -1;
                });
                offerLinksBio = offerDocuments.filter(document => {
                    if (!document.url || !document.label) return false;

                    return document.url.toUpperCase().indexOf('MONO') === -1;
                });

                offerDocuments = offerType === OFFER_TYPE.bio ? offerLinksBio : offerLinksMono;

            } else {
                console.log('Not filtering documents');
            }
            
            if (!offerDocuments || !Array.isArray(offerDocuments) || offerDocuments.length === 0) {
                console.log('Setting default documents');
                switch (true) {
                    case parsedOffer.energy.length === 0: offerDocuments = ACCORDION_LINKS.gas; break;
                    case parsedOffer.gas.length !== 0 && parsedOffer.offerType === OFFER_TYPE.bio: offerDocuments = ACCORDION_LINKS.energyGasBio; break;
                    case parsedOffer.gas.length !== 0 && parsedOffer.offerType !== OFFER_TYPE.bio: offerDocuments = ACCORDION_LINKS.energyGasMono; break;
                    case parsedOffer.offerType === OFFER_TYPE.bio: offerDocuments = ACCORDION_LINKS.energyBio; break;
                    case parsedOffer.offerType !== OFFER_TYPE.bio: offerDocuments = ACCORDION_LINKS.energyMono; break;
                    default: { }
                }
            }

            dispatch(offerSet(
                parsedOffer, 
                offerId, 
                offerDocuments,
                offerLinksBio,
                offerLinksMono,
                coupon
            ));

            if (!shouldShowPopupSelectedType) {
                dispatch(changeOfferResetState());
            } else if (!(parsedOffer.energy && parsedOffer.energy.length > 0)) {
                dispatch(changeOfferResetState());
            } else {
                dispatch(changeOfferTypeSetPopupOpen(true))
            }
        } catch (error) {
            
        }
    }
}

export function offer(state = initialState, action) {
    switch (action.type) {
        case OFFER_SET: {
            return { 
                ...state, 
                ...action.offer, 
                offerId: action.offerId, 
                offerLinks: action.offerLinks,
                offerLinksBio: action.offerLinksBio,
                offerLinksMono: action.offerLinksMono,
                coupon: action.coupon || state.coupon,
            }
        }
        case OFFER_COUPON_INVALID: {
            return {
                ...state,
                isCouponInvalid: true,
            }
        }
        default: {
            return state;
        }
    }
}